import React from 'react';
import { Alert, Grid } from '@nextiva/next-ui-components';

interface RegistrationPendingAlertProps {
  isPublic: boolean;
  isSoleProprietor: boolean;
  isBrandVerified: boolean;
  isAuthVettingActive: boolean;
  has24HoursPassed: boolean;
}
const dataTestId = 'PlatformAdminUI-Messaging-RegistrationPending-Alert';
export function RegistrationPendingAlert({
  isPublic,
  isSoleProprietor,
  isBrandVerified,
  isAuthVettingActive,
  has24HoursPassed,
}: RegistrationPendingAlertProps) {
  const showAlertPending =
    (!isPublic && !isSoleProprietor) ||
    (isPublic && isBrandVerified && isAuthVettingActive);
  const showAlertPendingBrandEmail = isPublic && !isAuthVettingActive;
  const showAlertPendingSoleProprietor =
    isSoleProprietor && !has24HoursPassed && !isBrandVerified;

  let alertSeverity: 'info' | 'warning' = 'info';
  let alertMessage = null;
  if (showAlertPending) {
    alertSeverity = 'info';
    alertMessage = 'Turnaround is typically 10-30 business days.';
  } else if (showAlertPendingBrandEmail) {
    alertSeverity = 'info';
    alertMessage =
      'Turnaround is typically 10-30 business days after brand verification and email authorization is complete.';
  } else if (showAlertPendingSoleProprietor) {
    alertSeverity = 'warning';
    alertMessage =
      'A text message has been sent to your phone number for business messaging registration verification. Please respond within 24 hours to complete the process.';
  }
  if (
    showAlertPending ||
    showAlertPendingBrandEmail ||
    showAlertPendingSoleProprietor
  ) {
    return (
      <Grid item xs={12}>
        <Alert severity={alertSeverity} fullWidth data-testid={dataTestId}>
          <span>{alertMessage}</span>
        </Alert>
      </Grid>
    );
  }
  return null;
}
